import useCartStore from '@/stores/cartStore';
import { ProductListItem } from '@/types';
import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';

export const useAddToCart = () => {
    const { addToCart, toggleOpen, isVariationInCart } = useCartStore(
        useShallow((state) => ({
            addToCart: state.addToCart,
            toggleOpen: state.toggleOpen,
            isVariationInCart: state.isVariationInCart,
        })),
    );

    return useCallback(
        (variation: ProductListItem) => {
            if (variation.inStock) {
                if (isVariationInCart(variation.id)) {
                    toggleOpen();
                } else {
                    addToCart(variation);
                }
            }
        },
        [addToCart, toggleOpen, isVariationInCart],
    );
};
